// extracted by mini-css-extract-plugin
export var chatHtmlText = "_pn-2";
export var chatLink = "_pn-0";
export var chatText = "_pn-1";